"use client";

import styles from "./TermsNotice.module.css";
import { FormattedMessage } from "react-intl";
import TermsModalLink from "./TermsModalLink";

export default function TermsNotice() {
  return (
    <div className={styles.notice}>
      <FormattedMessage
        id="auth-terms-notice"
        values={{
          link: (
            <TermsModalLink className={styles.link} key="auth-terms-link">
              <FormattedMessage id="footer-terms" />
            </TermsModalLink>
          ),
        }}
      />
    </div>
  );
}
